/* import __COLOCATED_TEMPLATE__ from './ic-legacy-modal-header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();